<p>payment-form-dialog-wrapper works!</p>
